import { MapCluster } from '../models/map.cluster';
import { MapMarker } from '../models/map.marker';

declare var H: any;

export class HMapCluster extends MapCluster {
    private clusterProvider: any;
    private defaultTheme: any;
    private points: any = [];

    constructor(id: number, maxZoom: number, mapComponent: any, map: any) {
        super(id, mapComponent, map, maxZoom);
        this.clusterProvider = new H.clustering.Provider(this.points, {
            providerOptions: {
                strategy: H.clustering.Provider.Strategy.DYNAMICGRID,
                max: maxZoom,
                eps: 32,
                minWeight: 2
            }
        });
        this.defaultTheme = this.clusterProvider.getTheme();
        const customTheme = {
            getClusterPresentation: (cluster: any) => {
                const clusterMarker = this.defaultTheme.getClusterPresentation.call(this.defaultTheme, cluster);
                return clusterMarker;
            },
            getNoisePresentation: (noisePoint: any) => {
                const mapMarker = noisePoint.getData();
                mapMarker.marker = new H.map.Marker(mapMarker.position, {
                    icon: new H.map.Icon(mapMarker.icon),
                    min: noisePoint.getMinZoom(),
                    max: 22,
                    volatility: true,
                    visible: mapMarker.visible,
                    draggable: mapMarker.drag,
                    zIndex: mapMarker.zIndex
                });
                mapMarker.marker.setData({ id: mapMarker.id, title: mapMarker.title, content: mapMarker.content });
                mapMarker.marker.addEventListener('pointerenter', (event: any) => {
                    this.mapComponent.onMarkerPointerEnter(event);
                });
                mapMarker.marker.addEventListener('pointerleave', (event: any) => {
                    this.mapComponent.onMarkerPointerLeave();
                });
                return mapMarker.marker;
            }
        };
        this.clusterProvider.setTheme(customTheme);
        map.addLayer(new H.map.layer.ObjectLayer(this.clusterProvider));
        this.clusterProvider.addEventListener('tap', (event: any) => {
            this.mapComponent.onMarkerClickEvent(event);
        });
    }

    addMarker(marker: MapMarker) {
        const point = new H.clustering.DataPoint(marker.position.lat, marker.position.lng);
        point.data = marker;
        this.clusterProvider.addDataPoint(point);
        this.points.push(point);
        //this.clusterProvider.setDataPoints(this.points);
    }

    removeMarker(marker: MapMarker) {
        this.points.forEach((point: any) => {
            if (point.data.id === marker.id) {
                this.clusterProvider.removeDataPoint(point);
                return;
            }
        });
    }

    removeMarkers() {
        this.points.forEach((point: any) => {
            this.clusterProvider.removeDataPoint(point);
        });
    }

    repaint() {
        // No se implementa en Here
    }

}
